const UNAVAILABLE = 'camera.unavailable';

// navigator.mediaDevices is absent outside a secure context (plain-http LAN address) and in
// many mobile in-app browsers, so it must be checked before use — reading through it throws.
export const isCameraSupported = (): boolean =>
  Boolean(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

export const listVideoInputs = async (): Promise<MediaDeviceInfo[]> => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    return [];
  }
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.filter((device) => device.kind === 'videoinput');
  } catch (error) {
    console.error('Error enumerating devices:', error);
    return [];
  }
};

export const requestCameraStream = (constraints: MediaStreamConstraints): Promise<MediaStream> => {
  if (!isCameraSupported()) {
    return Promise.reject(new Error(UNAVAILABLE));
  }
  return navigator.mediaDevices.getUserMedia(constraints);
};

export const cameraErrorKey = (error: any): string => {
  if (error?.message === UNAVAILABLE) {
    return UNAVAILABLE;
  }
  switch (error?.name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'camera.permission_denied';
    case 'NotFoundError':
    case 'DevicesNotFoundError':
    case 'OverconstrainedError':
      return 'camera.not_found';
    case 'NotReadableError':
    case 'TrackStartError':
    case 'AbortError':
      return 'camera.in_use';
    default:
      return 'camera.error';
  }
};
